import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogout } from "./api";

const AuthCtx = createContext({
  user: null,
  loading: true,
  error: null,
  refresh: () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const u = await authMe();
      setUser(u);
    } catch (err) {
      setUser(null);
      if (err?.isAuthError) {
        // Expired or missing session — Protected routes redirect to /login.
        setError(null);
      } else if (!err?.response) {
        setError("network");
      } else {
        setError("server");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await authLogout(); }
    catch (e) { console.error("logout failed:", e); }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, error, refresh, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
